import { showToast } from 'components/sharedCode/Utils/showToastWrapper';
import { useRemindersStore } from 'components/sharedCode/stores/remindersStore';
import useStore from 'components/sharedCode/stores/store';
import { subscribeDoc, subscribeUserDoc } from 'util/db';
import { initUserDataCall } from '../cloudFunctionCaller';
import { getStorageValue, setStorageValue } from '../utils/localStorage';

export const initDashboard = async () => {
    let userId = useStore.getState().authUser.uid;
    subscribeUserDoc(userId);
};

export const initDashboardLogic = async (userData) => {
    let userId = useStore.getState().authUser.uid;
    if (userData === null) {
        let res: any = await initUserDataCall();
        if (res?.data?.success) {
            subscribeUserDoc(userId);
        } else {
            showToast(
                'Something went wrong',
                'Unable to fetch userdata, please refresh',
                'error'
            );
        }
        return;
    }
    let wsDocId = await getCurrentLocalWs(userData);
    if (wsDocId) {
        subscribeDoc(wsDocId, 'items');
    } else {
        console.error('No valid workspace ID found, skipping subscription');
        showToast('Workspace Error', 'Unable to load workspace data', 'error');
    }

    if (
        userData.stripeSubscriptionStatus &&
        userData.stripeSubscriptionStatus === 'active'
    ) {
        useRemindersStore.getState().fetchReminders();
    } else {
        useRemindersStore.getState().setRemindersData('noActivePlan');
    }
    useStore.setState({
        //@ts-ignore
        userData: userData,
        userStatus: 'signedIn'
    });
};

export const getCurrentLocalWs = async (userData = null) => {
    let localDocRef = await getStorageValue('localWSRef');
    // console.log('localDocRef', localDocRef);

    if (localDocRef && localDocRef !== 'null') {
        // Validate that the workspace still exists in user's workspace list
        if (userData && userData.workspaces) {
            const workspaceExists = userData.workspaces.some(ws => ws.id === localDocRef);
            if (workspaceExists) {
                return localDocRef;
            } else {
                // Workspace no longer exists, clear localStorage and fall back to first workspace
                console.log('Cached workspace no longer exists:', localDocRef);
                await setStorageValue('localWSRef', null);
            }
        } else {
            return localDocRef; // Return if userData not available yet
        }
    }
    
    // Fall back to first available workspace
    try {
        if (userData && userData.workspaces && userData.workspaces.length > 0) {
            localDocRef = userData.workspaces[0].id;
            setStorageValue('localWSRef', localDocRef);
            return localDocRef;
        } else {
            showToast('No Workspaces', 'No accessible workspaces found', 'error');
            return null;
        }
    } catch (error) {
        console.error('Error getting workspace:', error);
        showToast('Something went wrong', 'Unable to load workspace', 'error');
        return null;
    }
};
